import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { RightActions } from '../styled';
import { GenerateQrDialogProps } from '../types/busTypes';
import Icons from '../../../components/icons';
import steps from '../utils/qrGenerationSteps';
import DialogModal from '../../../components/DialogModal';
import { copyQrBusPayload } from '../utils/utils';

const GenerateQrDialog: React.FC<GenerateQrDialogProps> = ({
  open,
  bus,
  onClose,
  showToast
}) => {
  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title='Follow below steps to generate the QR'
      maxWidth='sm'
      actions={
        <RightActions>
          <Button
            variant='contained'
            style={{
                justifyContent: "flex-end"
            }}
            onClick={() => bus && copyQrBusPayload(bus, showToast)}
            startIcon={<Icons.Copy />}
          >
            Copy To Clipboard
          </Button>
        </RightActions>
      }
    >
      <Box display='flex' flexDirection='column' gap={1} mt={1}>
        {steps.map((step, id) => (
          <Typography key={id} variant='body2' sx={{ textTransform: 'none' }}>
            {id + 1}. {step}
          </Typography>
        ))}
      </Box>
    </DialogModal>
  );
};

export default GenerateQrDialog;
